/* B.LÊM · Página inicial — profundidade leve no scroll da abertura (garrafa sobe mais devagar do que o painel) */
(() => {
  const root = document.querySelector('[data-rb]');
  if (!root || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const hero = root.querySelector('.rb-hero'), medal = root.querySelector('.rb-hero__medal'), tiles = root.querySelector('.rb-tiles');
  if (!hero || !medal || !tiles) return;
  // depois da entrada, a paralaxe passa a ser imediata (sem transição)
  setTimeout(() => root.classList.add('is-ready'), 2800);
  let tick = false;
  const upd = () => {
    tick = false;
    const r = hero.getBoundingClientRect();
    if (r.bottom < 0 || r.top > innerHeight) return;
    const y = Math.max(0, -r.top);
    medal.style.setProperty('--my2', (y * -0.08).toFixed(1) + 'px');
    tiles.style.setProperty('--ty2', (y * 0.05).toFixed(1) + 'px');
  };
  document.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { capture: true, passive: true });
})();

/* Origem: o mapa desenha-se quando entra; passar por um licor acende o seu lugar */
(() => {
  const og = document.querySelector('[data-og]');
  if (!og) return;
  const show = () => og.classList.add('is-in');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { show(); io.disconnect(); } }), { threshold: 0.25 });
    io.observe(og);
    setTimeout(show, 8000);
  } else show();
  const pts = [...og.querySelectorAll('[data-pt]')];
  const on = k => pts.forEach(p => p.classList.toggle('is-on', p.dataset.pt === k));
  og.querySelectorAll('[data-og-pt]').forEach(a => {
    a.addEventListener('mouseenter', () => on(a.dataset.ogPt));
    a.addEventListener('focus', () => on(a.dataset.ogPt));
    a.addEventListener('mouseleave', () => on(null));
    a.addEventListener('blur', () => on(null));
  });
})();
